import {Row, Col, Image} from 'react-bootstrap';
import React, {Component} from 'react';
import classnames from 'classnames';

import './identityCardType.css';
import CheckboxCustom from "../checkbox_custom/CheckboxCustom";

export const VALID_TYPE_IDENTITY_VALUES = {CHL2: 'CHL2', CHL3: 'CHL3'};

class IdentityCardType extends Component{
    constructor(props) {
        super(props);

        this.onChangeHandler = this.onChangeHandler.bind(this);
    }

    onChangeHandler(event){
        event.preventDefault();
        const valueSelected = event.currentTarget.getAttribute('value');
        if(Object.keys(VALID_TYPE_IDENTITY_VALUES).includes(valueSelected)){
            this.props.onChangeHandler(valueSelected);
        }
    }

    render(){
        return (
            <Row className={classnames('card-type',{
                'card-type-with-border': this.props.cardTypeSelected === this.props.cardTypeToCompare,
            })}>
                <Col xs={12}
                     onClick={this.onChangeHandler}
                     value={this.props.cardTypeToCompare}
                >
                    <CheckboxCustom
                        key={this.props.keyElement}
                        value={this.props.cardTypeToCompare}
                        name={this.props.name}
                        checked={this.props.checked}
                        text={this.props.text}
                     />
                    {this.props.image && <Image src={this.props.image} />}
                </Col>
            </Row>
        );
    }
}

export default IdentityCardType;
